import { getWarningText } from '@hungryroot/dietary-restrictions';
import { type DietaryRestrictionsText } from '@hungryroot/dietary-restrictions';
import { WarningTextStyleVariant } from '@hungryroot/pho';

export const getWarning = (
  dietaryIngredients: DietaryRestrictionsText[],
  ingredientContainsNeverPeriodicity: boolean
) => {
  const containsDietaryIngredients = dietaryIngredients.length > 0;

  if (containsDietaryIngredients) {
    return {
      warningText: `This recipe contains ${getWarningText(dietaryIngredients)}`,
      warningTextIntensity: WarningTextStyleVariant.Critical,
    };
  } else if (ingredientContainsNeverPeriodicity) {
    return {
      warningText: `This recipe contains items you set to 'never'`,
      warningTextIntensity: WarningTextStyleVariant.Moderate,
    };
  }
};
